<template>
  <div class="padded">
    <el-row>
      <el-col align="left">
      <edit-pane v-if="!hidePanel" ref="ep" prefix="Permit: ":title="form.summary"
        :editable="isManager('project|maintenance|finance|property|admin') ? true : false"
        :is-edit="editMode"
        @save="onSave" @cancel="onCancel" @edit="onEdit" @add="onSave" />

      <el-form ref="permitDetailsForm" :model="form" :rules="rules" label-width="90px">
        <select-site v-if="!localSiteId" v-model="form.site_id" required />

        <el-form-item prop="permitType" label="Permit">
          <el-input v-model="form.permitType" :disabled="disabled" placeholder="Permit Type (e.g. Microwave License)" />
        </el-form-item>

        <select-authority v-model="form.organisation_id" required :disabled="disabled" />

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <date-input v-model="form.applied" label="Applied" :disabled="disabled" />
          </el-col>

          <el-col :sm="24" :md="12" :lg="8">
            <date-input v-model="form.issued" label="Issued" :disabled="disabled" />
          </el-col>

          <el-col :sm="24" :md="12" :lg="8">
            <date-input v-model="form.expiry" label="Expiry" :disabled="disabled" />
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="amount" label="Amount">
              <el-input-number v-model="form.amount" :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <select-frequency label="Period" v-model="form.renewalPeriod" :disabled="disabled" />
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ref1" :label="label1">
              <el-input v-model="form.ref1" :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="ref2" :label="label2">
              <el-input v-model="form.ref2" :disabled="disabled" />
            </el-form-item>
          </el-col>
        </el-row>

        <html-input label="Remarks" v-model="form.remarks" :disabled="disabled" />

      </el-form>
    </el-col>
  </el-row>

  <div v-if="form.updated_at">
    <hr />
    <span class="pull-right">Last update: <b>{{formatFriendlyDate(form.updated_at)}}</b><span v-if="form.updated_by"> by {{form.updated_by}}</span></span>
  </div>

  <el-row v-if="canAccess('finance|admin|management') && form.site_id && form.id">
    <el-col :span="24">
        <files-panel title="Permits" type="site" :id="form.site_id" process="permits" :process-id="form.id" :max-files="20" />
    </el-col>
  </el-row>

</div>

</template>


<script>
import SiteMixins from '@/mixins/SiteMixins'

import {settings} from '@/components/Data'

import SelectAuthority from '@/components/atoms/selects/SelectAuthority'

export default {

  mixins: [SiteMixins],

  components: {
    SelectAuthority
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    siteId: {
      type: Number,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'permittable'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  methods: {

    success (response) {
      this.form = response
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.disabled = false
      this.onSave()
    },

    onSave () {
      if (!this.form.site_id && this.localSiteId) {
        this.form.site_id = this.localSiteId
      }

      this.form.applied = this.formatDateSql(this.form.applied)
      this.form.issued = this.formatDateSql(this.form.issued)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.saveForm(this, '/permits', this.form.id, this.form, this.form.summary, this.success, null, true, this.tableRef)
      this.disabled = true
    }

  },


  data () {
    return {
      disabled: true,
      format: settings.selectDateFormat,
      localData: this.rowData,
      localSiteId: (this.site_id ? this.site_id : (this.rowData.site_id && this.rowData.coverage ? this.rowData.id : this.rowData.site_id)),
      form: this.adding ? this.getTableStruct('permits') : this.rowData,
      label1: settings.ref1Label,
      label2: settings.ref2Label,
      rules: {
        permitType: [
          { required: true, message: 'Please input permit type', trigger: 'blur' },
          { min: 3, message: 'Length should be 3 or more characters', trigger: 'blur' }
        ]
      }
    }
  },


  created () {
//    console.log('PermitDetails(', this.adding, this.siteId, ')')

    if (this.adding) {
      this.disabled = false
      this.form.applied = new Date()
      delete this.form.id
    }


    this.form.site_id = (this.adding ? this.localSiteId : this.form.site_id)
    this.localSiteId = (this.siteId != null ? this.siteId : this.form.site_id)

    if (this.form.site_id && !this.localSiteId) {
      this.localSiteId = this.form.site_id
    }
  }

}

</script>



// WEBPACK FOOTER //
// PermitDetails.vue?71810c8f